import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  DialogActions,
  Button,
  Box,
  IconButton, TextField, Select, MenuItem, FormControl, CircularProgress,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { Formik } from "formik";
import CloseIcon from "@material-ui/icons/CloseRounded";
import Grid2 from "@mui/material/Unstable_Grid2";

const useStyles = makeStyles((theme) => ({
  accessBox: {
    display: "flex",
    flexFlow: "column",
  },
  publishButton: {
    color: theme.palette.common.white,
  },
  scrollContainer: {
    maxHeight: "70vh",
    overflowY: "auto",
    backgroundColor: "#f3f3f3",
  },
  dialogPaper: {
    maxWidth: '800px',
  },
}));

export default function ProfileDialogComponent({
  open,
  handleSubmit,
  handleClose,
}) {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      scroll="paper"
      classes={{ paper: classes.dialogPaper }}
      fullWidth
    >
      <Formik
        initialValues={{
          oldPassword: "",
          newPassword: "",
          confirmPassword: "",
        }}
        enableReinitialize
        onSubmit={handleSubmit}
      >
        {(formik) => (
          <form onSubmit={formik.handleSubmit}>
            <DialogTitle id="scroll-dialog-title">
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Box flexGrow={1}>
                    <Typography fontSize={16}>
                      Reset Password
                    </Typography>
                  </Box>
                </Box>

                <IconButton
                  size="small"
                  color="inherit"
                  onClick={handleClose}
                  style={{ padding: 0 }}
                >
                  <CloseIcon />
                </IconButton>
              </Box>
            </DialogTitle>
            <DialogContent style={{ backgroundColor: 'white' }} dividers className={classes.scrollContainer}>
              <Box className={classes.accessBox} mt={2} display="flex" flexDirection="column" style={{ columnGap: 2 }}>
                <Grid2 container rowSpacing={2}>
                  <Grid2 xs={4} display="flex" alignItems="center">
                    <Typography fontSize={16}>
                      Old Password
                    </Typography>
                  </Grid2>
                  <Grid2 xs={8}>
                    <TextField
                      fullWidth
                      label="Old Password"
                      name="oldPassword"
                      type="password"
                      value={formik.values.oldPassword}
                      onChange={formik.handleChange}
                      variant="outlined"
                    />
                  </Grid2>
                  <Grid2 xs={4} display="flex" alignItems="center">
                    <Typography fontSize={16}>
                      New Password
                    </Typography>
                  </Grid2>
                  <Grid2 xs={8}>
                    <TextField
                      fullWidth
                      label="New Password"
                      name="newPassword"
                      type="password"
                      value={formik.values.newPassword}
                      onChange={formik.handleChange}
                      variant="outlined"
                    />
                  </Grid2>
                  <Grid2 xs={4} display="flex" alignItems="center">
                    <Typography fontSize={16}>
                      Confirm Password
                    </Typography>
                  </Grid2>
                  <Grid2 xs={8}>
                    <TextField
                      fullWidth
                      label="Confirm Password"
                      name="confirmPassword"
                      type="password"
                      value={formik.values.confirmPassword}
                      onChange={formik.handleChange}
                      variant="outlined"
                    />
                  </Grid2>
                </Grid2>
                <Box mt={2} />
              </Box>
            </DialogContent>
            <DialogActions>
              <Button
                variant="text"
                type="button"
                onClick={handleClose}
                style={{ color: "black" }}
              >
                Cancel
              </Button>
              <Button variant="contained" type="submit">
                Submit
              </Button>
            </DialogActions>
          </form>
        )}
      </Formik>
    </Dialog>
  );
}
